export default __webpack_public_path__ + "static/media/services-banner.d2ed96bd.jpg";